import { Button, Image, Radio } from '@smartgift/frontend-toolkit';
import styled, { css } from 'styled-components';

const getWidthValue = width => {
  if (!width) return 'auto';
  return typeof width === 'number' ? `${width}px` : width;
};

const ImagePreviewBox = styled.div`
  border-radius: var(--size-border-radius-md);
  height: 100%;
  overflow: hidden;
  position: relative;
  width: 100%;
`;

const BowImage = styled(Image)`
  position: absolute;
  right: -28px;
  top: -16px;
`;

const ImagePreview = styled.div`
  align-items: center;
  cursor: pointer;
  display: flex;
  justify-content: center;
  min-width: ${({ width }) => getWidthValue(width)};
  overflow: hidden;
  position: relative;
  width: ${({ width }) => getWidthValue(width)};

  img {
    aspect-ratio: 100 / 100;
    object-fit: contain;
    width: 100%;
  }

  ${({ hasBorder }) =>
    hasBorder &&
    css`
      border: 1px solid var(--color-border-default);
      border-radius: var(--size-border-radius-md);

      ${({ active }) =>
        active &&
        css`
          border: 2px solid var(--color-accent-primary-default);

          :hover {
            border: 2px solid var(--color-accent-primary-default) !important;
          }
        `}

      :hover {
        border-color: var(--color-border-strong);
      }
    `}

  :hover {
    ${Radio.S.Input} {
      opacity: 1;
    }
  }

  ${({ active }) =>
    active &&
    css`
      ${Radio.S.Input} {
        opacity: 1 !important;
      }
    `}

  ${({ disabled }) =>
    disabled &&
    css`
      opacity: 0.4;

      :hover {
        border-color: var(--color-border-default);

        ${Radio.S.Input} {
          opacity: 0.4;
        }
      }
    `}
`;

const DeleteButton = styled(Button)`
  background: var(--color-bg-body);
  border: 1px solid var(--color-accent-secondary-default);
  border-radius: var(--size-border-radius-circle);
  display: flex;
  height: 24px;
  justify-content: center;
  position: absolute;
  right: 4px;
  top: 4px;
  width: 24px;

  &:hover {
    background: var(--color-accent-secondary-default);
  }
`;

const RadioButton = styled.div`
  ${Radio.S.Input} {
    left: 4px;
    opacity: 0.4;
    position: absolute;
    top: 4px;
  }
`;

export { BowImage, DeleteButton, ImagePreview, ImagePreviewBox, RadioButton };
